import services from './services';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import areaSelect from 'area-select';
export default {
    mixins: [services],
    components: {
        areaSelect
    },
    data() {
        return {
            addAddressVisible: false,
            AddressList: [],
            loading: false,
            SchoolId: 0,
            Address: this.initArea(),
            form: this.initConsignee(), //新增收货信息
            form2: this.initConsignee2(),
            isChange: false, //是否显示修改按钮
            title: '新增收货地址'
        }
    },
    methods: {
        initArea() {
            return cloneDeep({
                Provinces_Id: "",
                City_Id: "",
                Area_Id: ""
            });
        },
        initConsignee() {
            return cloneDeep({
                "Id": 0,
                "SchoolId": 0,
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeProvince": 0,
                "ConsigneeCity": 0,
                "ConsigneeArea": 0,
                "ConsigneeAdress": "",
                "IsDefault": true //1默认是
            });

        },
        // 联帮在家 下单家长收货地址数据
        initConsignee2() {
            return cloneDeep({
                "UserId": 0,
            });

        },
        //新增地址 修改
        addAddress() {
            let address = this.$refs.area.validate();
            if (!!address) {
                this.form.ConsigneeProvince = address.Provinces_Id;
                this.form.ConsigneeCity = address.City_Id;
                this.form.ConsigneeArea = address.Area_Id;
            }
            this.form.SchoolId = this.SchoolId
            // 判断
            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "详细地址",
                    value: this.form.ConsigneeAdress,
                    required: true,
                }, {
                    name: "联系人",
                    value: this.form.Consignee,
                    required: true,
                }, {
                    name: "联系电话",
                    value: this.form.ConsigneeTel,
                    phone: true,
                }]
            });

            if (!flag) {
                return;
            }
            if (this.form2.UserId !== 0) {
                this.UserConsigneeSave()
            } else {
                this.addSchoolConsigneeList()
            }

        },
        show(options) {
            this.addAddressVisible = true;
            this.SchoolId = options.SchoolId;
            this.isChange = false

            if (options.ParentId) {
                this.form2.UserId = options.ParentId
                this.form.Consignee = options.ParentName
                this.form.ConsigneeTel = options.ParentPhoneNo
                this.GetBabyConsigneeList(this.form2.UserId)
                this.isChange = true
            } else {
                this.getSchoolConsigneeList(this.SchoolId)
            }
        },
        //选中该行地址
        currentRow(row) {
            this.$emit('address', row)
            this.addAddressVisible = false;
        },
        // 修改地址
        changeAddress(index, item) {
            console.log(item)
            this.title = '修改收货地址'
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: this.SchoolId,
                Id: item.Id
            };
            this.form.Id = item.Id
            this.form.Consignee = item.Consignee
            this.form.ConsigneeTel = item.ConsigneeTel
            this.form.ConsigneeProvince = item.ConsigneeProvince
            this.form.ConsigneeCity = item.ConsigneeCity
            this.form.ConsigneeArea = item.ConsigneeArea
            this.form.ConsigneeAdress = item.ConsigneeAdress
            if (item.IsDefault == 1) {
                this.form.IsDefault = true
            } else {
                this.form.IsDefault = false
            }
            this.form.IsDefault = item.IsDefault
            this.Address = []
            this.Address.Provinces_Id = item.ConsigneeProvince * 1
            this.Address.City_Id = item.ConsigneeCity * 1
            this.Address.Area_Id = item.ConsigneeArea * 1

        },
        //设置默认地址
        setIsDefault(index, item) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: this.SchoolId,
                Id: item.Id
            };
            if (this.form2.UserId !== 0) {
                this.form.Id = item.Id
                this.form.Consignee = item.Consignee
                this.form.ConsigneeTel = item.ConsigneeTel
                this.form.ConsigneeProvince = item.ConsigneeProvince
                this.form.ConsigneeCity = item.ConsigneeCity
                this.form.ConsigneeArea = item.ConsigneeArea
                this.form.ConsigneeAdress = item.ConsigneeAdress
                this.UserConsigneeSave()
            } else {
                this.getSchoolAddressList(params)
            }

        }

    },
    computed: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/MeetOrder/components/AddressDialog/vm.js